import Vue from "vue";
import { Datetime } from "vue-datetime";
import ProgressC from "./components/ProgressC";
import MInfo from "./components/MInfo";
import MAlert from "./components/MAlert";
import MButton from "./components/MButton";
import MChip from "./components/MChip";
import MLabelVal from "./components/MLabelVal";
import MDatePicker from "./components/MDatePicker";
import MDateTimePicker from "./components/MDateTimePicker";
import MFABPlus from "./components/MFABPlus.vue";
import MCard from "./components/MCard.vue";
import MCardList from "./components/MCardList.vue";
import MDialog from "./components/MDialog.vue";
import MListTileInfo from "./components/MListTileInfo";
import MMenu from "./components/MMenu";
import MBreadcrum from "./components/MBreadcrum";
import MUploadFileDialog from "./components/MUploadFileDialog";
import MUpload from "./components/MUpload";
import MGrid from "./components/MGrid";
import MDialogInfo from "./components/InfoDialog";

Vue.component("progress-c", ProgressC);
Vue.component("m-labelval", MLabelVal);
Vue.component("m-button", MButton);
Vue.component("m-chip", MChip);
Vue.component("m-datepicker", MDatePicker);
Vue.component("m-datetimepicker", MDateTimePicker);
Vue.component("m-fab-plus", MFABPlus);
Vue.component("m-card", MCard);
Vue.component("m-card-list", MCardList);
Vue.component("m-dialog", MDialog);
Vue.component("m-list-tile-info", MListTileInfo);
Vue.component("m-menu", MMenu);
Vue.component("m-breadcrum", MBreadcrum);
Vue.component("m-upload", MUploadFileDialog);
Vue.component("m-upload-single", MUpload);
Vue.component("m-info", MInfo);
Vue.component("m-alert", MAlert);
Vue.component("grid-c", MGrid);
Vue.component("dialog-info", MDialogInfo);

Vue.component("datetime", Datetime);
